import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Tooltip from './Tooltip'
import '../../css/Tooltip.scss'

export default class SearchTooltip extends Component {
  static propTypes = {
    columns: PropTypes.array.isRequired
  }

  get content() {
    return (
      <div>
        <ol>
          <li>
            <p>Search by specifics columns using a search operator.</p>
            <pre>column: search term</pre>
            <p>Available columns:</p>
            <p>
              {this.props.columns.map((column, index) => {
                return <strong key={`search_column_${index}`}>{column}</strong>
              })}
            </p>
          </li>
          <li>
            <p>Search for exact matches using double quotes.</p>
            <pre>column: &quot;search term&quot;</pre>
          </li>
          <li>
            <p>Join multiple columns using &apos;|&apos;.</p>
            <pre>column1: search term1 | column2: search term2</pre>
          </li>
        </ol>
      </div>
    )
  }

  render() {
    return <Tooltip title="Advanced Search">{this.content}</Tooltip>
  }
}
